import { useCallback } from 'react';
import { useSharedValue } from 'react-native-reanimated';
import { days, months, daysShort } from '../utils';
const useFormatTimestampWorklet = (originalDataShared, type, showTime = true, period, isAlpacaAccount) => {
    const typeShared = useSharedValue(type);
    const showTimeShared = useSharedValue(showTime);
    const periodShared = useSharedValue(period);
    showTimeShared.value = showTime;
    periodShared.value = period;
    typeShared.value = type;
    const formatTimestampWorklet = useCallback((value) => {
        'worklet';
        const formatDate = (d, includeTime, showToday = true) => {
            let h = d.getHours();
            if (h < 10) {
                h = `0${h}`;
            }
            let m = d.getMinutes();
            if (m < 10) {
                m = `0${m}`;
            }
            let D = typeShared.value === 'stock' ? daysShort[d.getDay()] : days[d.getDay()];
            const now = new Date();
            if (showToday &&
                now.getFullYear() === d.getFullYear() &&
                now.getMonth() === d.getMonth() &&
                now.getDate() === d.getDate()) {
                D = 'Today';
            }
            let result = `${D}, ${d.getDate()} ${months[d.getMonth()]}`;
            if (now.getFullYear() !== d.getFullYear()) {
                result += ` ${d.getFullYear()}`;
            }
            if (includeTime) {
                result = `${h}:${m} ${result}`;
            }
            return result;
        };
        if (typeof value === 'number') {
            // value is like 1635427800 (UNIX timestamp in seconds, but may be additionally divided by 60)
            const multiplier = typeShared.value === 'stock' ? 60000 : 1000;
            return formatDate(new Date(value * multiplier), showTimeShared.value !== false);
        }
        if (typeShared.value === 'stock') {
            if (originalDataShared &&
                originalDataShared.value &&
                originalDataShared.value.timestamps &&
                originalDataShared.value.timestamps.length) {
                switch (periodShared.value) {
                    case '1D':
                        return formatDate(new Date(), false, false);
                    case '1W':
                        return 'in the last 7 days';
                    case '1M':
                        return 'in the last 30 days';
                    case '1Y':
                        return 'in the last year';
                    case 'MAX': {
                        const firstPoint = originalDataShared.value.timestamps[0];
                        return `since ${formatDate(new Date(firstPoint * 60000), false, false)}`;
                    }
                    default:
                        // should techically never get here, but still there is a small chance - when originalDataShared is undefined (until graph is loaded)
                        return '';
                }
            }
            return '';
        }
        return formatDate(new Date(), !!isAlpacaAccount);
    }, 
    // we need to recreate this worklet when period changes, so that the worklet gets executed
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [typeShared, showTimeShared, periodShared, originalDataShared, period]);
    return formatTimestampWorklet;
};
export default useFormatTimestampWorklet;
